import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'

import { useSOPNotificationRead } from '../SOPsDialog.hooks'

export default function Acknowledge({ notification }) {
  const read = useSOPNotificationRead()
  const handleRead = () => read.mutate(notification?.sopNotification.id)
  const acknowledged = Boolean(notification?.readAt)

  if (!notification) return null

  return (
    <FormControlLabel
      label="I acknowledge that I have read and understood the updated SOP content"
      disabled={read.isPending}
      control={
        <Checkbox
          checked={acknowledged}
          onChange={!acknowledged ? handleRead : undefined}
          sx={{ '& .MuiSvgIcon-root': { fontSize: 40 } }}
        />
      }
    />
  )
}
